import { useEffect, useState } from "react";
import { fetchUserDetails } from "../apis/user.api";

// Strict admin-ROLE check (permission_name === "admin"), not the "admin" permission — which the role
// matrix also grants to "tech". Used to gate Delhivery ops. Returns undefined until the role resolves,
// so callers can avoid flashing admin-only UI before we know. Falls back to the cached user_role.
export const useIsAdmin = (): boolean | undefined => {
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchUserDetails()
      .then((res) => {
        if (cancelled) return;
        const role =
          res?.branch?.user_permission?.permission_name ??
          localStorage.getItem("user_role");
        setIsAdmin(role === "admin");
      })
      .catch(() => {
        if (!cancelled)
          setIsAdmin(localStorage.getItem("user_role") === "admin");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return isAdmin;
};

export default useIsAdmin;
